// Ensure window.ShopifyCart is initialized for the premium checkout experience
if (!window.ShopifyCart) {
  window.ShopifyCart = {
    state: null,
    listeners: [],
    
    getItems() {
      if (!this.state || !this.state.items) return [];
      
      const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (this.state && this.state.currency) || 'USD';
      const formatMoney = (cents) => {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: activeCurrency });
      };

      return this.state.items.map(item => {
        let sizeText = '';
        let colorText = '';
        if (item.options_with_values) {
           item.options_with_values.forEach(opt => {
             const name = opt.name.toLowerCase();
             if (name === 'size') sizeText = opt.value;
             if (name === 'color' || name === 'colour') colorText = opt.value;
           });
        }
        
        let cleanImg = item.image || (item.featured_image ? item.featured_image.url : '');
        if (cleanImg && cleanImg.startsWith('//')) {
          cleanImg = 'https:' + cleanImg;
        }

        return {
          id: item.variant_id || item.id,
          key: item.key,
          title: item.product_title || item.title,
          price: formatMoney(item.final_line_price / Math.max(item.quantity, 1)),
          image: cleanImg,
          size: sizeText,
          color: colorText,
          quantity: item.quantity
        };
      });
    },
    
    async fetchState() {
      try {
        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const res = await fetch(rootUrl + 'cart.js');
        const cart = await res.json();
        this.state = cart;
        this.updateHeaderCount();
        return cart;
      } catch (err) {
        console.error('Failed to fetch cart', err);
        return null;
      }
    },
    
    async refresh() {
      await this.fetchState();
      document.dispatchEvent(new CustomEvent('wearjags-cart-updated'));
    },
    
    async addItem(item) {
      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      try {
         await fetch(rootUrl + 'cart/add.js', {
           method: 'POST',
           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
           body: JSON.stringify({
             items: [{
               id: parseInt(String(item.id).replace('placeholder-', ''), 10) || parseInt(item.id, 10),
               quantity: item.quantity || 1
             }]
           })
         });
         await this.refresh();
         document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
         
         const drawer = document.querySelector('cart-drawer');
         if (drawer && typeof drawer.open === 'function') {
           drawer.open();
         }
      } catch(e) { console.error('Failed to add item to cart', e); }
    },
    
    async updateQuantity(id, qty) {
      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      try {
         await fetch(rootUrl + 'cart/change.js', {
           method: 'POST',
           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
           body: JSON.stringify({
             id: String(id),
             quantity: parseInt(qty, 10)
           })
         });
         await this.refresh();
         document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      } catch(e) { console.error(e); }
    },
    
    async removeItem(id) {
       await this.updateQuantity(id, 0);
    },
    
    updateHeaderCount() {
      if (!this.state) return;
      const totalCount = this.state.item_count || 0;
      const bubble = document.getElementById('wj-cart-count-bubble');
      if (bubble) {
        bubble.textContent = totalCount;
        if (totalCount > 0) {
          bubble.style.display = 'flex';
          bubble.style.opacity = '1';
        } else {
          bubble.style.display = 'none';
        }
      }
      const headerTriggerCount = document.querySelector('.wj-cart-count');
      if (headerTriggerCount) {
        headerTriggerCount.textContent = totalCount;
      }
    }
  };
  
  // Initial fetch
  window.ShopifyCart.fetchState();

  // Listen to Dawn's global pubsub for cart updates (e.g. from Cart Page)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.ShopifyCart.refresh();
    });
  }
  
  document.addEventListener('cart:updated', () => {
    window.ShopifyCart.refresh();
  });
}

if (typeof window.showPremiumToast !== 'function') {
  window.showPremiumToast = function(message) {
    let toast = document.getElementById('premium-quickview-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'premium-quickview-toast';
      toast.style.position = 'fixed';
      toast.style.bottom = '24px';
      toast.style.right = '24px';
      toast.style.backgroundColor = '#121212';
      toast.style.color = '#ffffff';
      toast.style.padding = '12px 24px';
      toast.style.borderRadius = '4px';
      toast.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
      toast.style.fontFamily = "'Inter', sans-serif";
      toast.style.fontSize = '12px';
      toast.style.fontWeight = '500';
      toast.style.zIndex = '1000000';
      toast.style.transition = 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
      document.body.appendChild(toast);
    }
    
    toast.innerText = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
    
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
    }, 2500);
  };
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Override outer HTML to set the slide container structure
    this.innerHTML = `
      <div class="cart-drawer__overlay" id="CartDrawer-Overlay"></div>
      <div class="drawer__inner" id="CartDrawer"></div>
    `;

    // Listen for Escape key
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Bind dark/light backdrop click close
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

    // Listen for custom state update notification event
    document.addEventListener('wearjags-cart-updated', () => {
      this.syncRealShopifyImages();
      this.renderPremiumDrawer();
    });

    // Populate initial state components
    this.syncRealShopifyImages();
    this.renderPremiumDrawer();

    // Hook standard accessibility on header icons
    this.setHeaderCartIconAccessibility();

    // Global event delegation as an absolute fallback to capture any cart triggers
    document.addEventListener('click', (event) => {
      const cartTrigger = event.target.closest('#wj-cart-trigger') || event.target.closest('#cart-icon-bubble') || event.target.closest('.wj-cart-trigger');
      if (cartTrigger) {
        event.preventDefault();
        event.stopPropagation();
        this.open(cartTrigger);
      }
    });
  }

  syncRealShopifyImages() {
    if (this._isSyncing) return;
    this._isSyncing = true;
    fetch(`${window.Shopify ? window.Shopify.routes.root : '/'}cart.js`)
      .then(res => res.json())
      .then(cart => {
        this._isSyncing = false;
        if (!cart || !cart.items) return;
        let updated = false;
        const items = (window.ShopifyCart && typeof window.ShopifyCart.getItems === 'function')
          ? window.ShopifyCart.getItems()
          : [];

        items.forEach(item => {
          const matched = cart.items.find(ci => String(ci.variant_id) === String(item.id) || String(ci.id) === String(item.id));
          if (matched && matched.image) {
            let cleanImg = matched.image;
            if (cleanImg.startsWith('//')) {
              cleanImg = 'https:' + cleanImg;
            }
            if (!item.image || item.image.includes('unsplash.com') || item.image.includes('placeholder') || item.image !== cleanImg) {
              item.image = cleanImg;
              updated = true;
            }
          }
        });

        if (updated && window.ShopifyCart) {
          window.ShopifyCart.updateHeaderCount();
          this.renderPremiumDrawer();
        }
      })
      .catch(err => {
        this._isSyncing = false;
        console.error("Error syncing Shopify images:", err);
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble') || document.querySelector('#wj-cart-trigger');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    
    // Remove default triggers and attach custom ones
    const newCartLink = cartLink.cloneNode(true);
    cartLink.parentNode.replaceChild(newCartLink, cartLink);

    newCartLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.open(newCartLink);
    });
    newCartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        event.stopPropagation();
        this.open(newCartLink);
      }
    });

    // Ensure the count bubble on the newly cloned element gets updated!
    if (window.ShopifyCart && typeof window.ShopifyCart.updateHeaderCount === 'function') {
      window.ShopifyCart.updateHeaderCount();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Sync theme mode and inherit visual glass variables from current header configuration
    const headerEl = document.querySelector('header-section');
    if (headerEl) {
      const headerStyles = window.getComputedStyle(headerEl);
      const variables = [
        '--glass-bg',
        '--glass-border',
        '--glass-text',
        '--glass-text-hover',
        '--glass-blur',
        '--glass-shadow',
        '--glass-accent',
        '--glass-divider',
        '--glass-inset'
      ];
      variables.forEach((variable) => {
        const val = headerStyles.getPropertyValue(variable);
        if (val) {
          this.style.setProperty(variable, val.trim());
        }
      });
      
      const currentTheme = headerEl.getAttribute('data-theme-mode') || 'dark';
      this.setAttribute('data-theme', currentTheme);
    } else {
      this.setAttribute('data-theme', 'dark');
    }

    this.syncRealShopifyImages();

    // Render latest state items before slide-in starts
    this.renderPremiumDrawer();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 10);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    // If shopify parses some states via AJAX, sync it back or force render
    this.renderPremiumDrawer();
    this.open();
  }

  parsePrice(priceStr) {
    if (!priceStr) return 0;
    let cleaned = priceStr.replace(/[^\d.,]/g, '');
    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    
    if (lastDot > lastComma) {
      cleaned = cleaned.replace(/,/g, '');
      return parseFloat(cleaned) || 0;
    } else if (lastComma > lastDot) {
      cleaned = cleaned.replace(/\./g, '').replace(/,/g, '.');
      return parseFloat(cleaned) || 0;
    } else {
      return parseFloat(cleaned) || 0;
    }
  }

  formatPrice(value, samplePriceString) {
    if (!samplePriceString) {
      const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (window.ShopifyCart && window.ShopifyCart.state && window.ShopifyCart.state.currency) || 'USD';
      return value.toLocaleString(undefined, { style: 'currency', currency: activeCurrency });
    }
    
    const firstDigitIndex = samplePriceString.search(/[0-9]/);
    if (firstDigitIndex === -1) {
      return samplePriceString + value.toFixed(2);
    }
    
    const lastDigitMatch = [...samplePriceString.matchAll(/[0-9]/g)].pop();
    const lastDigitIndex = lastDigitMatch ? lastDigitMatch.index : -1;
    
    const prefix = samplePriceString.substring(0, firstDigitIndex);
    const suffix = samplePriceString.substring(lastDigitIndex + 1);
    const digitsSection = samplePriceString.substring(firstDigitIndex, lastDigitIndex + 1);
    
    const hasComma = digitsSection.includes(',');
    const hasDot = digitsSection.includes('.');
    
    const decimalMatch = digitsSection.match(/[.,](\d{2})$/);
    const decimalLen = decimalMatch ? 2 : 0;
    
    let formattedValue = value.toFixed(decimalLen);
    
    const lastDot = digitsSection.lastIndexOf('.');
    const lastComma = digitsSection.lastIndexOf(',');
    
    let separatorStyle = 'default';
    if (lastComma > lastDot && hasDot) {
      separatorStyle = 'european';
    } else if (hasComma && !hasDot) {
      if (decimalMatch && decimalMatch[0].startsWith(',')) {
        separatorStyle = 'comma-decimal';
      } else {
        separatorStyle = 'comma-thousands';
      }
    } else if (hasDot && !hasComma) {
      if (decimalMatch && decimalMatch[0].startsWith('.')) {
        separatorStyle = 'dot-decimal';
      } else {
        separatorStyle = 'dot-thousands';
      }
    }
    
    const parts = formattedValue.split('.');
    let integerPart = parts[0];
    const fractionalPart = parts[1] || '';
    
    if (separatorStyle === 'european' || separatorStyle === 'dot-thousands') {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else if (separatorStyle === 'comma-decimal' || separatorStyle === 'dot-decimal') {
      // no thousands separator
    } else {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    let finalDigits = integerPart;
    if (decimalLen > 0) {
      const decSep = (separatorStyle === 'european' || separatorStyle === 'comma-decimal' || (decimalMatch && decimalMatch[0].startsWith(','))) ? ',' : '.';
      finalDigits += decSep + fractionalPart;
    }
    
    return prefix + finalDigits + suffix;
  }

  renderPremiumDrawer() {
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;

    // Read state items list
    const items = (window.ShopifyCart && typeof window.ShopifyCart.getItems === 'function')
      ? window.ShopifyCart.getItems()
      : [];

    // Empty Drawer Rendering (Step 3 design element)
    if (items.length === 0) {
      inner.innerHTML = `
        <div class="drawer__header-premium">
          <h2 style="color: #FFFFFF !important;">Cart</h2>
          <button class="close-btn" aria-label="Close cart">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="drawer__empty-state">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity: 0.5;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
          <p>Your premium selection is currently empty.</p>
          <button class="continue-shopping-btn">Continue Shopping</button>
        </div>
      `;

      // Bind close actions
      inner.querySelector('.close-btn').addEventListener('click', () => this.close());
      inner.querySelector('.continue-shopping-btn').addEventListener('click', () => this.close());
      return;
    }

    // Interactive Populate Items Rendering
    let subtotal = 0;
    let itemsHtml = '';

    items.forEach((item) => {
      const numericPrice = this.parsePrice(item.price);
      subtotal += numericPrice * item.quantity;

      itemsHtml += `
        <div class="cart-drawer-item-card" data-item-id="${item.id}">
          <div class="item-image-wrapper">
             <img src="${item.image || ''}" alt="${item.title}" class="item-image" loading="lazy" referrerPolicy="no-referrer">
          </div>
          <div class="item-details">
            <h3 class="item-title">${item.title}</h3>
            <p class="item-meta">
              <span>Size: <b>${item.size}</b></span>
              <span>Color: <b>${item.color}</b></span>
            </p>
            <span class="item-price">${item.price}</span>
            
            <div class="item-actions-row">
              <div class="quantity-pill">
                <button class="quantity-btn dec-btn" data-item-id="${item.id}">-</button>
                <span class="quantity-val">${item.quantity}</span>
                <button class="quantity-btn inc-btn" data-item-id="${item.id}">+</button>
              </div>
              
              <button class="remove-btn" data-item-id="${item.id}">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    const firstItemPrice = items[0] ? items[0].price : '';
    const formattedSubtotal = this.formatPrice(subtotal, firstItemPrice);

    inner.innerHTML = `
      <div class="drawer__header-premium">
        <h2 style="color: #FFFFFF !important;">Cart (${items.reduce((acc, curr) => acc + curr.quantity, 0)})</h2>
        <button class="close-btn" aria-label="Close cart">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
      
      <div class="drawer__body-premium">
        ${itemsHtml}
      </div>
      
      <div class="drawer__footer-premium">
        <div class="subtotal-row">
          <span class="subtotal-label">Subtotal</span>
          <span class="subtotal-val">${formattedSubtotal}</span>
        </div>
        <p class="taxes-notice">Shipping and taxes calculated at checkout. Ambient secure glass encryption active.</p>
        
        <button class="checkout-btn-premium" id="wj-checkout-btn">
          <span>Secure Checkout</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
        </button>
      </div>
    `;

    // Bind Header close btn
    inner.querySelector('.close-btn').addEventListener('click', () => this.close());

    // Bind Quantity controls decrease
    inner.querySelectorAll('.dec-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-item-id');
        const item = items.find(i => i.id === id);
        if (item && window.ShopifyCart) {
          window.ShopifyCart.updateQuantity(id, item.quantity - 1);
        }
      });
    });

    // Bind Quantity controls increase
    inner.querySelectorAll('.inc-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-item-id');
        const item = items.find(i => i.id === id);
        if (item && window.ShopifyCart) {
          window.ShopifyCart.updateQuantity(id, item.quantity + 1);
        }
      });
    });

    // Bind Remove button controls
    inner.querySelectorAll('.remove-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-item-id');
        if (window.ShopifyCart) {
          window.ShopifyCart.removeItem(id);
          if (typeof showPremiumToast === 'function') {
            showPremiumToast('Item removed from selection');
          }
        }
      });
    });

    // Checkout redirect feedback trigger
    const checkoutBtn = inner.querySelector('#wj-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => {
        checkoutBtn.innerHTML = 'Securely Connecting...';
        checkoutBtn.setAttribute('disabled', 'true');
        setTimeout(() => {
          if (typeof showPremiumToast === 'function') {
            showPremiumToast('Connecting checkout gateway...');
          }
          setTimeout(() => {
            if (window.ShopifyCart && typeof window.ShopifyCart.getItems === 'function') {
              const items = window.ShopifyCart.getItems();
              if (items.length > 0) {
                const permalinkParts = items.map(item => `${item.id}:${item.quantity}`);
                window.location.href = `/cart/${permalinkParts.join(',')}`;
              } else {
                window.location.href = '/checkout';
              }
            } else {
              window.location.href = '/checkout';
            }
          }, 800);
        }, 300);
      });
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
